import { useState, useCallback } from 'react';
import useEventListener from '../useEventListener';

/**
 * Returns real window height to fix problems with 100vh being cropped
 * by Safari bottom bar or Android Chrome app bar
 */
export default function use100vh() {
  const [height, setHeight] = useState(measureHeight);
  const setMeasuredHeight = useCallback(() => {
    const measuredHeight = measureHeight();
    setHeight(measuredHeight);
  }, []);
  useEventListener('resize', setMeasuredHeight);
  return height ? `${height}px` : '100vh';
}
export function measureHeight() {
  var _document$documentEle;
  return ((_document$documentEle = document.documentElement) == null ? void 0 : _document$documentEle.clientHeight) || window.innerHeight;
}